<template>
  <div class="wind-farm-project-detail-container">
    <router-view name="Modal"></router-view>

    <PointItem
      ref="point"
      v-if="activePointItem"
      :itemConfig.sync="activePointItem"
      @del="handleResDel"
      @add="creatPointItem"
      @updateItem="uploadItemList"
    />
    <FaceItem
      ref="face"
      v-if="activeFaceItem"
      :itemConfig.sync="activeFaceItem"
      @updateItem="uploadItemList"
      @updateImg="updateMapItemsIMG"
      @setNoIdFaceItem = "setNoIdFaceItem"
    />

    <modal
            title="数据下载"
            :visible.sync="showDataDownLoadDialog"
            @close="dialogClose"
            width="400px"
    >
      <div class="data-content" style="padding:10px;">
        <el-form
                ref="form"
                :rules="uploadrules"
                :model="uploadForm"
                label-width="120px"
        >
          <el-form-item label="数据源" prop="datasetCode">
            <el-select
                    style="width: 220px"
                    v-model="uploadForm.datasetCode"
                    @change="handleDataDownChange"
            >
              <el-option
                      v-for="(item, index) in dataDownSet"
                      :key="index"
                      :label="item.label"
                      :value="item.value"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="开始时间" prop="startDate">
            <el-date-picker
                    v-model="uploadForm.startDate"
                    type="date"
                    placeholder="选择开始日期"
                    value-format="yyyy-MM-dd"
                    :default-value="defaultStartDate"
            >
            </el-date-picker>
          </el-form-item>
          <el-form-item label="结束时间" prop="endDate">
            <el-date-picker
                    v-model="uploadForm.endDate"
                    type="date"
                    placeholder="选择开始日期"
                    value-format="yyyy-MM-dd"
                    :default-value="defaultEndDate"
            >
            </el-date-picker>
          </el-form-item>
        </el-form>
        <div class="vtn-wrp">
<!--          <ct-button type="primary" :btnClick="handleDatasetClick"-->
<!--          >下载</ct-button>-->
          <el-button type="primary" class="downBtn" :class="uploadDisable ? 'disDownBtnColor' :'downBtnColor' " @click="handleDatasetClick" :disabled="uploadDisable">下载</el-button>
        </div>
      </div>
    </modal>

    <div class="wind-farm-project-detail-bar">
      <div class="nav-bar">
        <i
          class="el-icon-arrow-left"
          @click="
            () => {
              $router.push({
                name: 'project-list'
              });
            }
          "
        ></i>
        <div class="input-container">
          <div
            @click.stop.prevent="handlePlainTextClick"
            class="plain-text"
            v-if="!isProjectNameEdit"
          >
            {{ projectName }}
          </div>
        </div>
      </div>
      <div class="content-bar">
        <div class="content">
          <div v-if="false" class="farm">
            <div class="title">
              风电场
            </div>
            <div class="inner-content">
              <Card
                v-for="(item, index) in farmList"
                :key="index"
                useModel
                useEdit
                :isEditWindFarm.sync="item.isEditWindFarm"
                :header.sync="item.name"
                :showContent.sync="item.isShow"
                :precondition="handlePrecondition"
                @titleClick="handleCardTitleClick(item)"
                @check="handleWindFarmCheck(item, index)"
                @del="handleDelWindFarm(item, index)"
                @editClick="handleEditClick(item, index)"
                @cancel="handleWindFarmCancel(item)"
                @downClick="handleDownLoadWindFarm(item)"
                @financeClick="handleFinanceClick(item)"
                v-on:update:showContent="
                  val => {
                    handleShowContent(val, index, item);
                  }
                "
              >
                <FarmItem
                  v-if="item.isShow"
                  :id="item.id"
                  @showClick="handleWindFarmItemClick"
                ></FarmItem>
              </Card>
            </div>
          </div>
          <div class="resource">
            <div class="title">
              资源列表
            </div>
            <div class="inner-content">
              <Card header="区域查询">
                <ResItem
                  v-for="(item, index) in areasList"
                  :key="index"
                  :id="item.itemId"
                  :name.sync="item.itemName"
                  :label="item.label"
                  :active="activeFaceItem && item.itemId == activeFaceItem.itemId"
                  :visible="item.visible"
                  :isEditName="item.isEditName"
                  :isShowEditBtn="item.itemType != 4"
                  :itemType="item.itemType"
                  @edit="handleResEdit(item, index, 'face')"
                  @del="handleResDel(item, index, 'face')"
                  @check="handleResCheck(item, index, 'face')"
                  @cancel="handleResCancel(item, index, 'face')"
                  @iconClick="handleIconClick(item, index, 'face')"
                  @itemClick="handleItemClick(item, index, 'face', { setView: true })"
                ></ResItem>
              </Card>
              <Card header="点位查询">
                <ResItem
                  v-for="(item, index) in pointsList"
                  :key="index"
                  :id="item.itemId"
                  :name.sync="item.itemName"
                  :active="activePointItem && item.itemId == activePointItem.itemId"
                  :visible="item.visible"
                  :isEditName="item.isEditName"
                  :itemType="item.itemType"
                  @down="handleDownData(item)"
                  @edit="handleResEdit(item, index, 'point')"
                  @del="handleResDel(item, index, 'point')"
                  @check="handleResCheck(item, index, 'point')"
                  @cancel="handleResCancel(item, index, 'point')"
                  @iconClick="handleIconClick(item, index, 'point')"
                  @itemClick="handleItemClick(item, index, 'point', { setView: true })"
                ></ResItem>
              </Card>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import FaceItem from './components/face-item';
import PointItem from './components/point-item';
import ResItem from './components/resource-item';
import Card from '../card';
import FarmItem from '../farm-item';
import { mapGetters } from 'vuex';
import { Pop } from '@/utils';
import Vue from 'vue';
import TurPopContent from '../tur-pop-content';
// import GantaPopContent from '../ganta-content';
import cloneDeep from 'lodash/cloneDeep';
import flattenDepth from 'lodash/flattenDepth';
import {
  itemTypeMap,
  parseGeoInfoToMapData,
  calcAverage,
  toFixed,
  eventBus,
  findDeepId,
  calcAreaByData, getQueryString
} from '../utils';
import { getToken } from '@/utils';
import moment from 'moment';

let currentVue = null;
let currentP = null;
let currentMap = null;

export default {
  components: {
    Card,
    FarmItem,
    ResItem,
    FaceItem,
    PointItem
  },
  data() {
    this.eventBus = eventBus;

    return {
      activeEditWindFarm: null,
      isProjectNameEdit: false,
      farmList: [
        // {
        //   name: '风场1',
        //   id: '1',
        //   isEditWindFarm: false,
        //   isShow: false,
        //   geometryInfo:
        //     '{"type":"Polygon","coordinates":[[[108.37906732401514,39.98162727782423],[106.48892599037464,38.00164316609315],[109.91755445604808,36.955892959264716],[111.41208481288008,38.00164316609315],[108.37906732401514,39.98162727782423]]]}'
        // },
        // {
        //   name: '风场2',
        //   id: '2',
        //   isShow: false,
        //   isEditWindFarm: false,
        //   geometryInfo:
        //     '{"type":"Polygon","coordinates":[[[109.03861076719059,38.20903306004605],[108.11548321548432,35.681788425955595],[105.52193437973817,33.805001644418404],[106.13735274754235,36.17974719605064],[109.03861076719059,38.20903306004605]]]}'
        // },
        // {
        //   name: '风场3',
        //   id: '3',
        //   isShow: false,
        //   isEditWindFarm: false,
        //   geometryInfo:
        //     '{"type":"Polygon","coordinates":[[[117.97893148933767,42.68564427555694],[117.84707842479418,41.116468223878165],[115.29924366831811,41.64382434979986],[117.97893148933767,42.68564427555694]]]}'
        // }
      ],

      activePointItem: null,
      activeFaceItem: null,
      pointsList: [
        // {
        //   itemId: '1',
        //   itemName: '未命名',
        //   isEditName: false,
        //   visible: true,
        //   wipStore: {},
        //   lon: '1243',
        //   lat: '234',
        //   //
        //   datasetCode: '',
        //   datasetHeight: ''
        // },
        // {
        //   itemId: '2',
        //   itemName: '未命名2',
        //   isEditName: false,
        //   visible: true,
        //   wipStore: {},
        //   lon: '1243',
        //   lat: '234',
        //   //
        //   datasetCode: '',
        //   datasetHeight: ''
        // }
      ],
      areasList: [
        // {
        //   itemId: '1',
        //   itemName: '未命名',
        //   label: '多边形',
        //   isEditName: false,
        //   visible: true,
        //   wipStore: {},
        //   //
        //   elementCode: ''
        // },
        // {
        //   itemId: '2',
        //   itemName: '未命名2',
        //   label: '矩形',
        //   isEditName: false,
        //   visible: true,
        //   wipStore: {},
        //   //
        //   elementCode: ''
        // }
      ],
      noIdFaceItem:{
        datasetCode: '',
        datasetHeight: ''
      },
      itemList:[],
      plusImgArr: [],
      centerObj: {},
      projectName: '',
      turbineTypeList: [],
      currentItem: null,
      startDrag: false,
      hasDrag: null,
      windScopeData: null,
      isEditRoad: false,

      showDataDownLoadDialog: false,
      downItem: null,
      uploadrules: {
        datasetCode: [
          { required: true, message: '请选择数据源', trigger: 'change' }
        ],
        startDate: [
          { required: true, message: '请选择开始时间', trigger: 'change' }
        ],
        endDate: [
          { required: true, message: '请选择结束时间', trigger: 'change' }
        ]
      },
      uploadForm: {
        datasetCode: '',
        startDate: '',
        endDate: ''
      },
      defaultStartDate: '',
      defaultEndDate: '',
      defaultDatasetCode: null,
      dataDownSet: [],
      uploadDisable: false,
    };
  },
  computed: {
    ...mapGetters('WindFarm', [
      'specificDragFlag',
      'turbineList',
      'mapData',
      'windfarmRoadList',
      'mapData',
      'specificEditFlag',
      'specificChangeFlag',
      'polylinesIndexs',
      'resourceTupuObj',
      'windfarmWireForm',
      'gantaPointList'
    ])
  },

  watch: {
    resourceTupuObj: {
      handler(val) {
        if (Object.keys(val).length === 0) {
          this.plusImgArr = [
            {
              url: null
            }
          ];
          this.requestImg();
          return;
        }
        const { boundary = [], pic } = val;

        const data = [
          {
            lat: boundary[1],
            lng: boundary[0]
          },
          {
            lat: boundary[3],
            lng: boundary[2]
          },
          {
            lat: boundary[3],
            lng: boundary[0]
          },
          {
            lat: boundary[1],
            lng: boundary[2]
          }
        ];

        const url = `${
          process.env.VUE_APP_API_HOST
        }/windfarm/windfarm/getWrgPic?picName=${pic}&version=${new Date().valueOf()}`;

        this.plusImgArr = [
          {
            latlngs: data,
            url: url
          }
        ];

        this.requestImg();
      },
      deep: true
    }
  },
  created() {
    this.$store.commit('WindFarm/CLEAN_MAP');

    this.eventBus.$on('dragStartFj', this.dragStartFj);
    this.eventBus.$on('dragEndFj', this.dragEndFj);
    this.$bus.$on('updateWindFarmAndItems', this.updateWindFarmReducer);
    this.$bus.$on('clickFengji', this.handleFengjiClick);
    this.$bus.$on('clickGanta', this.handleGantaClick);
    this.$bus.$on('resultClickFj', this.resultFj);
    this.$bus.$on('resultClickDl', this.resultClickDl);
    this.$bus.$on('resultClickXl', this.resultClickXl);
    this.$bus.$on('roadSaveClick', this.roadSaveClick);
    this.$bus.$on('res-point-click', this.resPointMapElementClick);
    this.$bus.$on('res-face-click', this.resFaceMapElementClick);
    this.$bus.$on('wind-scope-click', this.windScopeClick);
    this.$bus.$on('wire-line-click', this.wireLineClick);
    this.$bus.$on('road-line-click', this.roadLineClick);
    this.$bus.$on('getWindScopeData', this.getWindScopeMapData);
    this.$bus.$on('clearHasDragControl', this.clearHasDragController);
    this.$bus.$on('resetActiveItem',this.resetActiveItem);
    this.projectName = localStorage.getItem('current-project-name');
    this.$bus.$on('showPoint',this.showPoint);
    this.$bus.$on('defaultPolygon',this.defaultPolygon);
    this.$bus.$on('defaultPoint',this.defaultPoint);

  },
  mounted() {
    document.body.addEventListener('click', this.handleBodyClick);
    this.queryWindfarmAndItemList(() => {this.cleanWindFarmInMap()});

    const container = document.querySelector('.wind-farm-main-container');
    const height = container.offsetHeight;

    const div = document.querySelector(
      '.wind-farm-project-detail-bar .content'
    );

    div.style.maxHeight = height - 100 + 'px';
  },
  beforeDestroy() {
    document.body.removeEventListener('click', this.handleBodyClick);
    this.eventBus.$off('dragStartFj', this.dragStartFj);
    this.eventBus.$off('dragEndFj', this.dragEndFj);
    this.$bus.$off('updateWindFarmAndItems', this.updateWindFarmReducer);
    this.$bus.$off('clickFengji', this.handleFengjiClick);
    this.$bus.$off('clickGanta', this.handleGantaClick);
    this.$bus.$off('resultClickFj', this.resultFj);
    this.$bus.$off('resultClickXl', this.resultClickXl);
    this.$bus.$off('resultClickDl', this.resultClickDl);
    this.$bus.$off('roadSaveClick', this.roadSaveClick);
    this.$bus.$off('res-point-click', this.resPointMapElementClick);
    this.$bus.$off('res-face-click', this.resFaceMapElementClick);
    this.$bus.$off('wire-line-click', this.wireLineClick);
    this.$bus.$off('wind-scope-click', this.windScopeClick);
    this.$bus.$off('road-line-click', this.roadLineClick);
    this.$bus.$off('getWindScopeData', this.getWindScopeMapData);
    this.$bus.$off('clearHasDragControl', this.clearHasDragController);
    this.$bus.$off('resetActiveItem',this.resetActiveItem);
    this.$bus.$emit('clearUnloginData');
    this.$bus.$off('showPoint');
    this.cleanWindFarmInMap(true);
    this.setSessionStorage('farmId', '');
    this.$bus.$off('defaultPolygon',this.defaultPolygon);
    this.$bus.$off('defaultPoint',this.defaultPoint);
  },
  methods: {
    //创建点
    creatPointItem(params){
      this.$bus.$emit('creatPointItem',params);
    },

    dialogClose() {},
    handleDataDownChange(val) {
      const item = this.dataDownSet.find(i => i.datasetCode === val) || {};
      this.defaultStartDate = item.startDate;
      this.defaultEndDate = item.endDate;
      this.defaultDatasetCode = item.label;

      this.uploadForm.startDate = this.defaultStartDate;
      this.uploadForm.endDate = this.defaultEndDate;
    },
    handleDownData(item) {
      this.uploadDisable = false;
      this.showDataDownLoadDialog = true;
      this.downItem = item;
      if (!this.dataDownSet.length) {
        this.$fetch('/windfarm/project/getDownDataSet').then(res => {
          const { data = {} } = res;
          const { dataSet = [] } = data;

          this.dataDownSet = dataSet.map(i => {
            return {
              ...i,
              label: i.datasetName,
              value: i.datasetCode
            };
          });
        });
      }
    },
    handleDatasetClick() {
      this.$refs.form.validate(valid => {
        if (valid) {
          if (
                  moment(this.uploadForm.startDate).isBefore(this.defaultStartDate) ||
                  moment(this.uploadForm.endDate).isAfter(this.defaultEndDate)
          ) {
            return this.$message.warning(
                    `超出数据源的时间范围，范围应在${this.defaultStartDate}至${this.defaultEndDate}之间`
            );
          }

          if (
                  moment(this.uploadForm.startDate).isAfter(this.uploadForm.endDate)
          ) {
            return this.$message.warning('结束时间不能超过开始时间');
          }

          const uploadForm = {
            ...this.uploadForm
          };

          uploadForm.startDate = uploadForm.startDate.replace(/-/g, '');
          uploadForm.endDate = uploadForm.endDate.replace(/-/g, '');

          const str =
                  process.env.VUE_APP_API_HOST +
                  '/windfarm/meso/point/getResourcesDataFile' +
                  getQueryString({
                    ...uploadForm,
                    itemId: this.downItem.itemId,
                    lat: this.downItem.lat,
                    lon: this.downItem.lon,
                    apiKey: getToken()
                  });

          this.$message.warning('下载中，请稍等');
          this.uploadDisable = true;
          // window.open(str, '_parent');

          fetch(str)
                  .then(res => {
                    return res.blob();
                  })
                  .then(data => {
                    const blob = new Blob([data]);

                    var link = document.createElement('a');
                    var fileURL = URL.createObjectURL(blob);

                    link.target = '_blank';
                    link.href = fileURL;
                    link.download = `${this.downItem.itemName}-${this.defaultDatasetCode}-${this.downItem.lon}-${this.downItem.lat}-点位数据.csv`;
                    link.click();
                    this.uploadDisable = false;
                  });
        }
      });
    },

    clearHasDragController() {
      this.hasDrag = null;
      if (currentP) {
        currentP.clear();
        currentP = null;
      }
    },
    getWindScopeMapData(callback) {
      callback(this.windScopeData);
    },
    handleDownLoadWindFarm(item) {
      this.$postForm({
        url: '/windfarm/windfarm/report/downReport',
        // method: 'POST',
        showLoading: true,
        showError: true,
        showSuccess: true,
        noJudge: true,
        data: {
          windfarmId: item.windfarmId
        }
      }).then(res => {
        const blob = new Blob([res.data]);
        var link = document.createElement('a');
        var fileURL = URL.createObjectURL(blob);
        link.target = '_blank';
        link.href = fileURL;
        link.download = '风场报告.doc';
        link.click();
      });
    },
    windScopeClick(data, isSetView) {
      if (isSetView) {
        const obj = {
          lat: calcAverage(data.map(i => i.lat)),
          lng: calcAverage(data.map(i => i.lng))
        };
        this.setMapView({ ...obj });
      }

      if (this.specificEditFlag) {
        const { polylines } = this.mapData;

        const res = polylines.some((item, index) => {
          this.$bus.$emit('getMapInstance', mapInstance => {
            this.isEditRoad = mapInstance.shapes.polylines[index].pm.enabled();

            if (this.isEditRoad) {
              mapInstance.shapes.polylines[index].pm.toggleEdit();
            }
          });

          return this.isEditRoad;
        });

        if (res) {
          this.roadSaveClick();
        }
      }

      // if (this.specificEditFlag) {
      //   // const { polylines } = this.mapData;
      //   this.roadSaveClick();
      //   // polylines.forEach((item, index) => {
      //   //   this.$bus.$emit('getMapInstance', mapInstance => {
      //   //     if (mapInstance.shapes.polylines[index].pm.enabled()) {
      //   //
      //   //     }
      //   //   });
      //   // });
      // }
    },
    resFaceMapElementClick(data) {
      let itemId = null;

      itemId = findDeepId(data);
      if (!itemId && itemId != 0) return;

      const faceItem = this.areasList.find(i => i.itemId === itemId);
      const index = this.areasList.findIndex(i => i.itemId === itemId);

      this.handleItemClick(faceItem, index, 'face', {
        force: true,
        setView: false
      });
    },
    resPointMapElementClick(data) {
      const { id } = data;

      const pointItem = this.pointsList.find(i => i.itemId === id);
      const index = this.pointsList.findIndex(i => i.itemId === id);

      this.handleItemClick(pointItem, index, 'point', {
        force: true,
        setView: false
      });
    },
    roadSaveClick() {
      // const lines = this.mapData.polylines; // 不能只是lines

      const lines = this.mapData.polylines.filter((item, index) =>
        this.polylinesIndexs.includes(index)
      );

      const arr = this.windfarmRoadList.map((i, index) => {
        return {
          geometryInfo: JSON.stringify({
            type: 'LineString',
            coordinates: lines[index]
              ? lines[index].map(i => [i.lng, i.lat])
              : ''
          }),
          roadId: i.roadId
        };
      });

      const roadIds = arr
        .filter(i => !!i.geometryInfo)
        .map(i => i.roadId)
        .join(',');
      const geometryInfos = arr
        .filter(i => !!i.geometryInfo)
        .map(i => i.geometryInfo)
        .join(';');

      this.$postForm('/windfarm/windfarm/updateWindfarmRoad', {
        showLoading: true,
        showError: true,
        showSuccess: true,
        data: {
          roadIds,
          geometryInfos,
          windfarmId: this.currentItem.windfarmId
        }
      }).then(() => {
        this.$store.dispatch('WindFarm/getRoadList', {
          params: {
            windfarmId: this.currentItem.windfarmId
          },
          callback: () => {
            this.resultClickDl();
          }
        });
      });
    },
    wireLineClick() {
      // if (this.specificChangeFlag && this.windfarmWireForm.type === '2') {
      //   const { polylines } = this.mapData;
      //   const _index = polylines.findIndex(line => line === data);
      //   polylines.forEach((item, index) => {
      //     if (_index === index) {
      //       this.$bus.$emit('getMapInstance', mapInstance => {
      //         if (!mapInstance.shapes.polylines[index].pm.enabled()) {
      //           mapInstance.shapes.polylines[index].pm.toggleEdit();
      //         }
      //       });
      //     } else {
      //       this.$bus.$emit('getMapInstance', mapInstance => {
      //         if (mapInstance.shapes.polylines[index].pm.enabled()) {
      //           mapInstance.shapes.polylines[index].pm.toggleEdit();
      //         }
      //       });
      //     }
      //   });
      // }
    },
    roadLineClick(data) {
      if (this.specificEditFlag) {
        const { polylines } = this.mapData;
        const _index = polylines.findIndex(line => line === data);

        polylines.forEach((item, index) => {
          if (_index === index) {
            this.$bus.$emit('getMapInstance', mapInstance => {
              if (!mapInstance.shapes.polylines[index].pm.enabled()) {
                mapInstance.shapes.polylines[index].pm.toggleEdit();
              }
            });
          } else {
            this.$bus.$emit('getMapInstance', mapInstance => {
              if (mapInstance.shapes.polylines[index].pm.enabled()) {
                mapInstance.shapes.polylines[index].pm.toggleEdit();
              }
            });
          }
        });
      }
    },
    resultClickXl() {
      // 架空
      if (this.windfarmWireForm.type === '1') {
        if (this.specificChangeFlag) {
          this.$store.commit('WindFarm/SET_specificChangeFlag', false);
          this.$store.commit('WindFarm/UPDATE_GANTALIST');

          this.$bus.$emit('getMapInstance', instance => {
            this.$store.commit('WindFarm/SET_MARKERS_DRAG', {
              type: 'gantaPoint',
              key: 'specificChangeFlag',
              mapInstance: instance,
              status: true
            });
          });
        } else {
          this.$store.commit('WindFarm/SET_specificChangeFlag', true);
          this.$store.commit('WindFarm/UPDATE_GANTALIST');
        }
      } else {
        // 埋地

        this.$bus.$emit('getMapInstance', instance => {
          this.$store.commit('WindFarm/SET_LINE_EDIT', {
            type: 'wirelist',
            mapInstance: instance,
            update: () => {
              this.$store.commit('WindFarm/SET_RAW_LINE', {
                type: 'wirelist',
                data: []
              });
              this.$store.commit('WindFarm/SET_LINE', []);

              this.$store.commit('WindFarm/UPDATE_ROAD_LIST');

              this.$store.dispatch('WindFarm/getWindFarmWire', {
                params: {
                  type: this.windfarmWireForm.type,
                  windfarmId: this.currentItem.windfarmId
                }
              });
            },
            key: 'specificChangeFlag'
          });
        });
      }
    },
    resultClickDl(force = true) {
      this.$bus.$emit('getMapInstance', instance => {
        this.$store.commit('WindFarm/SET_LINE_EDIT', {
          type: 'roadlist',
          force: force,
          mapInstance: instance,
          update: () => {
            this.$store.commit('WindFarm/SET_RAW_LINE', {
              type: 'roadlist',
              data: []
            });

            this.$store.commit('WindFarm/SET_LINE', []);

            this.$store.commit('WindFarm/SET_RAW_MARKERS', {
              type: 'keypoint',
              data: []
            });

            this.$store.commit('WindFarm/SET_RAW_MARKERS', {
              type: 'entrance',
              data: []
            });

            this.$store.dispatch('WindFarm/getRoadList', {
              params: {
                windfarmId: this.currentItem.windfarmId
              }
            });

            this.$store.commit('WindFarm/UPDATE_WIRE_LIST');

            // this.$store.dispatch('WindFarm/getWindFarmWire', {
            //   params: {
            //     type: this.windfarmWireForm.type,
            //     windfarmId: this.currentItem.windfarmId
            //   },
            //   usePrevShow: true
            // });
          }
        });
      });
    },
    resultFj(callback) {
      if (this.hasDrag) {
        this.$confirm('当前信息已更新，是否确认保存？', '提示', {
          confirmButtonText: '去保存',
          cancelButtonText: '取消',
          type: 'warning',
          closeOnClickModal: false
        })
          .then(() => {
            this.handleFengjiClick(this.hasDrag.data, currentMap);
          })
          .catch(() => {
            this.backToOrigin();
            this.$store.commit('WindFarm/UPDATE_TUILIST');

            this.$bus.$emit('getMapInstance', instance => {
              this.$store.commit('WindFarm/SET_MARKERS_DRAG', {
                type: 'fengji',
                mapInstance: instance,
                force: true
              });
            });
          });
        callback && callback(false);
        return;
      }

      if (this.specificDragFlag) {
        this.$store.commit('WindFarm/UPDATE_TUILIST');

        this.$nextTick(() => {
          this.$bus.$emit('getMapInstance', instance => {
            this.$store.commit('WindFarm/SET_MARKERS_DRAG', {
              type: 'fengji',
              mapInstance: instance
            });
          });
        });
      } else {
        this.$store.commit('WindFarm/SET_specificDragFlag', true);
      }

      this.hasDrag = null;
      if (currentP) {
        currentP.clear();
        currentP = null;
      }

      callback && callback(true);
      return true;
    },
    dragStartFj(data) {
      if (this.specificDragFlag) {
        this.$bus.$emit('getMapInstance', instance => {
          this.$store.commit('WindFarm/SET_MARKERS_DRAG', {
            type: 'fengji',
            mapInstance: instance,

            filter: current => {
              if (current.turbineId !== data.turbineId) {
                return true;
              }
            },
            status: false
          });
        });

        this.hasDrag = {
          data:
            this.hasDrag && data.turbineId === this.hasDrag.id
              ? this.hasDrag.data
              : data,
          hasDrag: true,
          id: data.turbineId
        };
      }

      // if (this.specificChangeFlag) {
      // this.$bus.$emit('getMapInstance', instance => {
      //   this.$store.commit('WindFarm/SET_MARKERS_DRAG', {
      //     type: 'gantaPoint',
      //     mapInstance: instance,
      //     filter: current => {
      //       if (current.gantaId !== data.gantaId) {
      //         return true;
      //       }
      //     },
      //     status: false
      //   });
      // });
      // this.hasDrag = {
      //   data:
      //     this.hasDrag && data.gantaId === this.hasDrag.id
      //       ? this.hasDrag.data
      //       : data,
      //   hasDrag: true,
      //   id: data.gantaId
      // };
      // }

      // 锁定其他markers
    },
    dragEndFj() {
      // //console.log(data);
      if (this.specificDragFlag) {
        if (currentP) {
          currentP.clear();
          currentP = null;
        }
      }
    },
    async queryTurbineList(windfarmId) {
      if (this.turbineTypeList.length) return this.turbineTypeList;

      return this.$fetch('/windfarm/windfarm/getAutoTurbineParam', {
        showError: true,
        params: {
          windfarmId
        }
      }).then(res => {
        const { data } = res;
        const { turbineTypeList } = data;

        this.turbineTypeList = turbineTypeList.map(i => {
          return {
            label: i.turbineType,
            value: i.turbineTypeId
          };
        });
        return this.turbineTypeList;
      });
    },

    afterSave(val) {
      this.hasDrag = null;
      if (currentP) {
        currentP.clear();
        currentP = null;
      }

      // TODO 如果是手输，要更新位置

      if (this.specificDragFlag) {
        this.queryWindfarmTurbineList(this.currentItem, () => {
          // 变成了true
          this.$bus.$emit('getMapInstance', instance => {
            this.$store.commit('WindFarm/SET_MARKERS_DRAG', {
              type: 'fengji',
              mapInstance: instance,
              filter: () => {
                return true;
              },
              status: true
            });
          });
        });
      }

      if (this.specificChangeFlag) {
        this.queryWires(
          this.currentItem,
          '1',
          () => {
            this.$bus.$emit('getMapInstance', instance => {
              this.$store.commit('WindFarm/SET_MARKERS_DRAG', {
                type: 'gantaPoint',
                mapInstance: instance,
                filter: () => {
                  return true;
                },
                status: true
              });
            });
          },
          true,
          val
        );
      }
    },

    afterDel(id) {
      if (currentP) {
        currentP.clear();
        currentP = null;
      }
      const index = this.turbineList.findIndex(item => item.turbineId == id);
      const newArr = [...this.turbineList];

      this.hasDrag = null;
      if (currentP) {
        currentP.clear();
        currentP = null;
      }

      newArr.splice(index, 1);
      this.$store.commit('WindFarm/SET_TURLIST', [...newArr]);
      this.$store.commit('WindFarm/UPDATE_TUILIST');

      this.$bus.$emit('getMapInstance', instance => {
        this.$store.commit('WindFarm/SET_MARKERS_DRAG', {
          type: 'fengji',
          mapInstance: instance,
          force: true
        });
      });
    },

    backToOrigin() {
      if (this.specificDragFlag) {
        const { id, data } = this.hasDrag;

        const index = this.turbineList.findIndex(item => item.turbineId == id);
        const newArr = [...this.turbineList];

        newArr[index] = {
          ...newArr[index],
          ...data
        };

        this.$store.commit('WindFarm/SET_TURLIST', [...newArr]);

        this.$store.commit('WindFarm/UPDATE_TUILIST', {
          activeId: id,
          force: true,
          callback: () => {
            this.$nextTick(() => {
              this.$bus.$emit('getMapInstance', instance => {
                this.$store.commit('WindFarm/SET_MARKERS_DRAG', {
                  type: 'fengji',
                  mapInstance: instance,
                  filter: () => true,
                  status: true
                });
              });
            });
          }
        });

        this.$bus.$emit('getMapInstance', instance => {
          this.$store.commit('WindFarm/SET_MARKERS_DRAG', {
            type: 'fengji',
            mapInstance: instance,
            filter: () => {
              return true;
            },
            status: true
          });
        });

        this.hasDrag = null;
        if (currentP) {
          currentP.clear();
          currentP = null;
        }
      }

      if (this.specificChangeFlag) {
        const { id, data } = this.hasDrag;

        const index = this.gantaPointList.findIndex(item => item.gantaId == id);
        const newArr = [...this.gantaPointList];

        newArr[index] = {
          ...newArr[index],
          ...data
        };

        this.$store.commit('WindFarm/SET_GANTALIST', [...newArr]);
        this.$store.commit('WindFarm/UPDATE_GANTALIST', {
          activeId: id,
          force: true,
          callback: () => {
            this.$nextTick(() => {
              this.$bus.$emit('getMapInstance', instance => {
                this.$store.commit('WindFarm/SET_MARKERS_DRAG', {
                  type: 'gantaPoint',
                  mapInstance: instance,
                  filter: () => {
                    return true;
                  },
                  status: true
                });
              });
            });
          }
        });

        this.hasDrag = null;
        if (currentP) {
          currentP.clear();
          currentP = null;
        }
      }
    },

    handleFengjiClick(data, map) {
      const { name } = this.$route;
      currentMap = map;
      // 在电量页查看风机
      if (name === 'power') {
        this.$bus.$emit('checkPowerInPower', data);
      }

      // 当前为拖拽状态
      if (this.specificDragFlag === true) {
        if (this.hasDrag && data.turbineId !== this.hasDrag.id) {
          return;
        }

        this.$store.commit('WindFarm/UPDATE_TUILIST', {
          activeId: data.turbineId,
          callback: () => {
            this.$nextTick(() => {
              this.$bus.$emit('getMapInstance', instance => {
                this.$store.commit('WindFarm/SET_MARKERS_DRAG', {
                  type: 'fengji',
                  mapInstance: instance,

                  filter: current => {
                    if (current.turbineId === data.turbineId) {
                      return true;
                    }
                  },
                  status: true
                });
              });
            });
          }
        });

        if (currentP) {
          currentP.clear();
          currentP = null;
        }

        currentP = new Pop();
        currentP.creatContent(
          {
            data,
            map
          },
          data => {
            const { turbineId } = data;

            return this.$fetch('/windfarm/windfarm/getWindfarmTurbine', {
              params: {
                turbineId: turbineId
              },
              showLoading: true,
              showError: true
            }).then(res => {
              const { data = {} } = res || {};
              const { windfarmTurbine = {} } = data;
              return {
                root: '<div id="fengji-pop-content"></div>',
                data: windfarmTurbine
              };
            });
          },
          async (dataInfo, rawData) => {
            const { lng: lon, lat } = rawData;

            const {
              turbineHubHeight,
              turbineTypeId,
              turbineType,
              turbineId,
              number
            } = dataInfo;

            if (currentVue) {
              currentVue.$destroy();
            }

            const obj = {
              id: turbineId,
              turbineType,
              height: turbineHubHeight,
              turbineTypeId: turbineTypeId,
              lon: this.toFixed(lon, 6),
              lat: this.toFixed(lat, 6),
              number: number,
              turList: await this.queryTurbineList(this.currentItem.windfarmId),
              windfarmId: this.currentItem.windfarmId,
              afterSave: val => {
                this.afterSave(val);
              },
              afterDel: id => {
                this.afterDel(id);
              },
              back: this.backToOrigin,
              hasDrag: this.hasDrag
            };

            this.$nextTick(() => {
              currentVue = new Vue({
                name: 'pop',
                render: h =>
                  h(TurPopContent, {
                    attrs: obj
                  }),
                el: document.querySelector('#fengji-pop-content')
              });
            });
          }
        );
      }
    },

    handleGantaClick() {
      // currentMap = map;
      // if (this.specificChangeFlag === true) {
      //   if (this.hasDrag && data.gantaId !== this.hasDrag.id) {
      //     return;
      //   }
      //   this.$store.commit('WindFarm/UPDATE_GANTALIST', {
      //     activeId: data.gantaId,
      //     circuit: data.circuit,
      //     callback: () => {
      //       this.$nextTick(() => {
      //         this.$bus.$emit('getMapInstance', instance => {
      //           this.$store.commit('WindFarm/SET_MARKERS_DRAG', {
      //             type: 'gantaPoint',
      //             mapInstance: instance,
      //             filter: current => {
      //               if (current.gantaId === data.gantaId) {
      //                 return true;
      //               }
      //             },
      //             status: true
      //           });
      //         });
      //       });
      //     }
      //   });
      //   if (currentP) {
      //     currentP.clear();
      //     currentP = null;
      //   }
      //   currentP = new Pop();
      //   currentP.creatContent(
      //     {
      //       data,
      //       map
      //     },
      //     data => {
      //       return {
      //         root: '<div id="ganta-pop-content"></div>',
      //         data: data
      //       };
      //     },
      //     async (dataInfo, rawData) => {
      //       const { lng: lon, lat } = rawData;
      //       if (currentVue) {
      //         currentVue.$destroy();
      //       }
      //       const obj = {
      //         id: data.gantaId,
      //         lon: this.toFixed(lon, 6),
      //         lat: this.toFixed(lat, 6),
      //         windfarmId: this.currentItem.windfarmId,
      //         back: this.backToOrigin,
      //         hasDrag: this.hasDrag,
      //         circuit: data.circuit,
      //         afterSave: this.afterSave
      //       };
      //       this.$nextTick(() => {
      //         currentVue = new Vue({
      //           name: 'pop',
      //           render: h =>
      //             h(GantaPopContent, {
      //               attrs: obj
      //             }),
      //           el: document.querySelector('#ganta-pop-content')
      //         });
      //       });
      //     }
      //   );
      // }
    },

    toFixed,

    queryWindfarmTurbineList(myItem, callback) {
      this.$store.dispatch('WindFarm/getWindfarmTurbineList', {
        params: {
          windfarmId: myItem.windfarmId
        },
        callback: callback
      });
    },

    updateMapItemsIMG(payload) {
      // const markers = this.pointsList
      //   .filter(i => i.visible)
      //   .map(i => {
      //     const { geometryInfo } = i;
      //     const latAndLon = JSON.parse(geometryInfo).coordinates || [];
      //     const [lon, lat] = latAndLon;

      //     return {
      //       lat: lat,
      //       lon: lon,
      //       id: i.itemId
      //     };
      //   });

      // const polygons = this.areasList
      //   .filter(i => i.visible)
      //   .map(i => {
      //     const data = parseGeoInfoToMapData(i.geometryInfo)[0];
      //     return [...data];
      //   });

      const { id, url } = payload;
        const item = this.areasList.find(i => i.itemId === id);
        if (item) {
          item.tupuUrl = url;
          this.requestImg();
        }


      // this.$store.commit('WindFarm/SET_RAW_MARKERS', {
      //   type: 'res-point',
      //   data:
      // });
    },

    handleEditClick(item) {
      item.activeEdit = true;
      const { polygons } = this.mapData;

      if (item.windfarmId === this.currentItem.windfarmId) {
        this.$store.commit(
          'WindFarm/SET_WINDFARM_EDIT_STATE',
          this.farmList.some(i => i.activeEdit)
        );

        polygons.forEach((i, index) => {
          const itesmsa = i[0];
          if (itesmsa?.type === 'windscope') {
            this.$bus.$emit('getMapInstance', instance => {
              item.currentMapPolygonsIndex = index;

              item.prevInstanceShape = instance.shapes.polygons[index].pm;
              item.prevInstanceShape.toggleEdit();
            });
          }
        });
      }
    },
    handleDelWindFarm(item) {
      this.$confirm(`是否删除该风场 ${item.name}`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
        closeOnClickModal: false
      }).then(async () => {
        await this.$postForm('/windfarm/windfarm/deleteWindfarm', {
          data: {
            windfarmId: item.id
          }
        });
        this.$router.push({
          name: 'project-detail',
          query: {
            projectId: this.$route.query.projectId
          }
        });

        this.cleanWindFarmInMap();

        this.queryWindfarmAndItemList(() => {
          this.$store.commit(
            'WindFarm/SET_WINDFARM_EDIT_STATE',
            this.farmList.some(i => i.activeEdit)
          );
        });
      });
    },

    handleWindFarmCancel(item) {
      if (item.activeEdit && this.currentItem.windfarmId === item.windfarmId) {
        item.prevInstanceShape?.toggleEdit();

        this.createWindFarmInMap(item.geometryInfo, false);
      }
      item.activeEdit = false;
      this.$store.commit(
        'WindFarm/SET_WINDFARM_EDIT_STATE',
        this.farmList.some(i => i.activeEdit)
      );
      item.currentMapPolygonsIndex = -1;
    },
    handleWindFarmCheck(item) {
      if (item.activeEdit && item.isShow) {
        const newPolygons = this.mapData.polygons[item.currentMapPolygonsIndex];
        const area = calcAreaByData(newPolygons, true);

        const newArr = newPolygons.concat(newPolygons[0]);
        const genJson = {
          type: 'Polygon',
          coordinates: [newArr.map(i => [i.lng, i.lat])]
        };

        const maxLats = Math.max(...newPolygons.map(i => i.lat));
        const minLats = Math.min(...newPolygons.map(i => i.lat));
        const minLngs = Math.min(...newPolygons.map(i => i.lng));
        const maxLngs = Math.max(...newPolygons.map(i => i.lng));

        if (maxLats > 90 || minLats < -90) {
          this.$message.warning('风场范围的纬度应在-90°至90°之间');
          // this.$store.commit('WindFarm/POP_MAPDATA_POLYGONS');
          return;
        }

        if (maxLngs > 180 || minLngs < -180) {
          this.$message.warning('风场范围的经度应在-180°至180°之间');
          // this.$store.commit('WindFarm/POP_MAPDATA_POLYGONS');
          return;
        }

        if (area > 5000) {
          return this.$message.warning('面积不能大于5000平方公里');
        }

        this.$postForm('/windfarm/station/redrawWindFarm', {
          data: {
            windfarmId: item.windfarmId,
            farmBoundary: JSON.stringify(genJson)
          },
          showError: true,
          showSuccess: true
        }).then(() => {
          item.prevInstanceShape.toggleEdit();
          item.activeEdit = false;
          item.currentMapPolygonsIndex = -1;

          this.createWindFarmInMap(JSON.stringify(genJson));

          this.queryWindfarmAndItemList(
            () => {
              this.$store.commit(
                'WindFarm/SET_WINDFARM_EDIT_STATE',
                this.farmList.some(i => i.activeEdit)
              );
            },
            {
              updateWindFarm: true,
              updateItemList: false
            }
          );

          // this.updateMapLayer(this.geoInfoData, false);
        });
      }

      this.$postForm('/windfarm/windfarm/updateWindfarmName', {
        showError: true,
        data: {
          projectId: this.$route.query.projectId,
          windfarmId: item.id,
          windfarmName: item.name
        }
      }).then(() => {
        item.isEditWindFarm = false;
      });
    },
    cleanWindFarmInMap(cleanAll = false) {
      if (cleanAll) {
        this.$nextTick(() => {
          this.$store.commit('WindFarm/CLEAN_MAP');
        });
      } else {
        this.$store.commit('WindFarm/CLEAN_MAP');
        this.requestImg();
        this.requestItemsElementMap('face');
        this.requestItemsElementMap('point');
      }
    },
    createWindFarmInMap(geometryInfo, setView = false) {
      if (!geometryInfo) return;

      const geoData = parseGeoInfoToMapData(geometryInfo)[0];

      this.windScopeData = geoData;

      this.geoInfoData = [geoData.map(i => ({ ...i, type: 'wind-scope' }))];
      this.updateMapLayer(this.geoInfoData, setView);
    },
    updateMapLayer(data, setView = true) {
      this.$store.commit('WindFarm/SET_RAW_POLYGONS', {
        type: 'windscope',
        data
      });

      const obj = {
        lat: calcAverage(data[0].map(i => i.lat)),
        lng: calcAverage(data[0].map(i => i.lng))
      };
      this.centerObj = obj;

      setView && this.setMapView(obj);
    },
    updateWindFarmReducer(payload) {
      const { data, type, setView } = payload;

      if (type === 'point' || type === 'poly') {
        this.createElementByType(data, type, setView);
      }

      if (type === 'windFarm') {
        if (this.farmList[0]) {
          this.farmList[0].isShow = false;
        }

        this.queryWindfarmAndItemList(() => {}, {
          windfarmId: data.windfarmId
        });
      }
    },

    createElementByType(projectItem, type, setView = false) {
      const noIdItem = this.getDefaultElement(type);
      if (type === 'point') {
        const fn = this.showPadByIdPoint(projectItem, setView,noIdItem);
        this.queryWindfarmAndItemList(fn);
      }
      if (type === 'poly') {
        const fn = this.showPadByIdPolygon(projectItem, setView,noIdItem);
        this.queryWindfarmAndItemList(fn);
      }
    },
    showPadByIdPolygon(item, setView,noIdItem) {
      return () => this.showPadId(item, 'face', setView,noIdItem);
    },
    showPadByIdPoint(item, setView,noIdItem) {
      return () => this.showPadId(item, 'point', setView,noIdItem);
    },
    showPadId(obj, type, setView,noIdItem) {
      let arr;
      if(noIdItem){
        if (type === 'face') {
          this.pointsList.push(noIdItem);
        }

        if (type === 'point') {
          this.areasList.push(noIdItem);
        }
      }
      if (type === 'face') {
        arr = this.areasList;
      }

      if (type === 'point') {
        arr = this.pointsList;
      }

      const item = arr.find(i => i.itemId === obj.itemId);
      const index = arr.findIndex(i => i.itemId === obj.itemId);

      this.handleItemClick({
        ...item,
        datasetCode: obj.datasetCode,
        datasetHeight: obj.datasetHeight,
      }, index, type, { setView });
    },
    getDefaultElement(type){
      let item = null;
      if(type === 'point'){
        item = this.areasList.find(i => i.itemId == 0)
      }
      if(type === 'poly'){
        item = this.pointsList.find(i => i.itemId == 0)
      }
      return item;
    },
    uploadItemList(obj){
      const index = this.itemList.findIndex(i => i.itemId == obj.itemId);
      if(index == -1){
        this.itemList.push(obj);
      }else{
        this.itemList[index] = obj;
      }

    },
    queryWindfarmAndItemList(
      callback = () => {},
      options = {
        updateWindFarm: true,
        updateItemList: true,
        windfarmId: ''
      }
    ) {
      const {
        updateWindFarm = true,
        updateItemList = true,
        windfarmId = ''
      } = options;

      this.$fetch('/windfarm/project/getWindfarmAndItemList', {
        params: {
          projectId: this.$route.query.projectId
        },
        showError: true
      }).then(res => {
        this.$store.dispatch('WindFarm/getDataSet');
        const { data = {} } = res;
        let { windfarmList = [], itemList = [] } = data;

        if (!Array.isArray(windfarmList)) {
          windfarmList = [];
        }
        if (!Array.isArray(itemList)) {
          itemList = [];
        }

        const existExpandId = windfarmId
          ? windfarmId
          : findShowId(this.farmList);

        if (updateWindFarm) {
          this.farmList = windfarmList.map(i => {
            return {
              id: i.windfarmId,
              name: i.windfarmName,
              isShow: existExpandId === i.windfarmId,
              activeEdit: false,
              currentMapPolygonsIndex: -1,
              isEditWindFarm: false,
              ...i
            };
          });
        }

        if (updateItemList) {
          this.pointsList = itemList
            .filter(i => i.itemType === 1)
            .map(i => {
              const item = findExistItem(this.pointsList, i.itemId);
              if (item) {
                return item;
              }

              const { geometryInfo } = i;
              const latAndLon = JSON.parse(geometryInfo).coordinates || [];
              const [lon, lat] = latAndLon;

              return {
                ...i,
                lon,
                lat,
                label: itemTypeMap.get(i.itemType),
                //
                isEditName: false,

                datasetCode: '',
                datasetHeight: '',
                visible: true,
                wipStore: {}
                // elementCode: ''
              };
            });

          this.areasList = itemList
            .filter(i => i.itemType !== 1)
            .map(i => {
              const item = findExistItem(this.areasList, i.itemId);
              if (item) {
                return item;
              }
              return {
                ...i,
                label: itemTypeMap.get(i.itemType),
                //
                isEditName: false,
                visible: true,
                wipStore: {},

                mapGeo: '',

                datasetCode: '',
                datasetHeight: '',
                elementCode: 'wspd',
                legendRange: '2',
                tupuUrl: ''
              };
            });
        }

        this.$nextTick(() => {
          this.expand(windfarmId);
          callback && callback(this.pointsList, this.areasList);
        });
      });

      function findShowId(arr) {
        const item = arr.find(i => i.isShow);
        if (item) {
          return item.id;
        } else {
          return null;
        }
      }

      function findExistItem(arr, id) {
        const item = arr.find(i => i.itemId === id);
        if (item) {
          return item;
        }
        return null;
      }
    },
    //临时点
    defaultPoint(item){
      const arr = this.pointsList
          .filter(i => i.itemId != 0)
          .map(ii => {
            return ii
          });
      arr.push(item);
      this.pointsList = [...arr];
    },
    //临时多边形
    defaultPolygon(polygon){
      const item = {
        ...polygon,
        label: itemTypeMap.get(polygon.itemType),
        //
        isEditName: false,
        visible: true,
        wipStore: {},
        mapGeo: '',
        elementCode: 'wspd',
        legendRange: '2',
        tupuUrl: '',
        ...this.noIdFaceItem
      };

      const arr = this.areasList
              .filter(i => i.itemId != 0)
              .map(ii => {
                return ii
              });
      arr.push(item);
      this.areasList = [...arr];
      this.$store.commit('WindFarm/POP_MAPDATA_RECT');
      this.requestItemsElementMap('face');
      let setView = { setView:false };
      if(item.itemType == 4){
        setView.setView = true;
      }
      this.handleItemClick(item, null, 'face', setView);
    },
    setNoIdFaceItem(params){
      this.noIdFaceItem = {
        ...params
      }
    },
    showPoint(item, setView) {
      this.activeFaceItem = null;
      this.activePointItem = item;

      if (setView) {
        this.setMapView(
          {
            lat: item.lat,
            lng: item.lon
          }
        );
      }
    },

    setMapView(latlng, zoom = '') {
      this.$bus.$emit('getMapInstance', instance => {
        instance.map.setView(
          {
            ...latlng
          },
          instance.map.getZoom() || zoom
        );
      });
    },
    resetActiveItem() {
      this.activePointItem = null;
      this.activeFaceItem = null;
    },
    showFace(item, setView) {
      this.activePointItem = null;
      this.activeFaceItem = item;

      let arr = [];

      if (item.itemType == '4') {
        const geoData = cloneDeep(item.mapGeo);
        this.getMap(geoData);
        arr = flattenDepth(geoData, 4);
      } else {
        arr = parseGeoInfoToMapData(item.geometryInfo)[0];
      }

      if (setView) {
        const obj = {
          lat: calcAverage(arr.map(i => i.lat)),
          lng: calcAverage(arr.map(i => i.lng))
        };

        this.setMapView(
          {
            ...obj
          }
        );
      }
    },
    async handleItemClick(
      item,
      index,
      type,
      option = {
        force: false,
        setView: false
      }
    ) {
      this.$bus.$emit('clearDetailModal');
      if (item.itemType == '4' && !item.mapGeo) {
        item.mapGeo = await this.queryBoundaryByregionId(item.adcode);
      }

      const { force = false, setView = false } = option;

      const datasetCode = this.itemList.find(i => i.itemId == item.itemId);
      if(datasetCode){
        item = {
          ...item,
          ...datasetCode
        }
      }
      if (type === 'face') {
        // this.$bus.$emit('clearDetailModal');
        if (force) {
          this.showFace(item, setView);
          this.requestImg();
          this.requestItemsElementMap(type);
          return;
        }
        if(item.itemId === this.activeFaceItem?.itemId) {
          this.resetActiveItem();
        }else{
          if(!item.visible) item.visible = true;
          this.showFace(item, setView);
        }

        this.requestImg();
        this.requestItemsElementMap(type);
      }

      if (type === 'point') {
        if (force) {
          this.showPoint(item, setView);
          // this.requestItemsElementMap(type);
          return;
        }

        if(item.itemId === this.activePointItem?.itemId) {
          this.resetActiveItem();
        }else{
          if(!item.visible) item.visible = true;
          this.showPoint(item, setView);
        }
        this.requestItemsElementMap(type);
      }
    },
    async handleIconClick(
      item,
      index,
      type
    ) {
      const { name, query } = this.$route;
      if (name !== 'project-detail') {
        this.$router.replace({
          name: 'project-detail',
          query: {
            projectId: query.projectId
          }
        });
      }

      if (item.itemType == '4' && !item.mapGeo) {
        item.mapGeo = await this.queryBoundaryByregionId(item.adcode);
      }

      if (type === 'face') {
        item.visible = !item.visible;
        if (item.visible) {
          this.showFace(item, true);
        } else {
          this.resetActiveItem();
        }
        this.requestImg();
        this.requestItemsElementMap(type);
      }

      if (type === 'point') {
        item.visible = !item.visible;
        if (item.visible) {
          this.showPoint(item, true);
        } else {
          this.resetActiveItem();
        }
        this.requestItemsElementMap(type);
      }
    },
    resetActiveStausOmitId(type, id) {
      if (type === 'face') {
        this.areasList.forEach(i => {
          if (i.itemId !== id) {
            i.visible = true;
          }
        });
      }
    },

    getMap(array, id = null) {
      if (!array.length) return array;

      if (Array.isArray(array) && typeof array[0] === 'number') {
        if (id === null || id === undefined) {
          array[0] = {
            lat: array[1],
            lng: array[0]
          };
        } else {
          array[0] = {
            id,
            lat: array[1],
            lng: array[0]
          };
        }

        array.length = 1;
        return 'change';
        // Reflect.deleteProperty(array, '1');
      } else {
        for (let i = 0; i < array.length; i++) {
          let flag = this.getMap(array[i], id);

          if (flag === 'change') {
            array[i] = array[i][0];
          }
        }
      }
    },

    requestImg() {
      let imgMapData = this.areasList
        .filter(i => i.visible)
        .filter(i => i.tupuUrl)
        .map(i => {
          if (i.itemType != 4) {
            const data = parseGeoInfoToMapData(i.geometryInfo)[0];

            let maxLat = -1000;
            let maxLng = -1000;
            let minLat = 1000;
            let minLng = 1000;

            data.forEach(item => {
              const { lat, lng } = item;

              if (maxLat < lat) {
                maxLat = lat;
              }

              if (minLat > lat) {
                minLat = lat;
              }

              if (maxLng < lng) {
                maxLng = lng;
              }

              if (minLng > lng) {
                minLng = lng;
              }
            });

            const _data = [
              {
                lat: maxLat,
                lng: minLng
              },
              {
                lat: maxLat,
                lng: maxLng
              },
              {
                lat: minLat,
                lng: maxLng
              },
              {
                lat: minLat,
                lng: minLng
              }
            ];

            return {
              url: i.tupuUrl,
              latlngs: _data
            };
          } else {
            const geoData = cloneDeep(i.mapGeo);
            this.getMap(geoData);
            const newData = flattenDepth(geoData, 4);

            let maxLat = -1000;
            let maxLng = -1000;
            let minLat = 1000;
            let minLng = 1000;

            newData.forEach(item => {
              const { lat, lng } = item;

              if (maxLat < lat) {
                maxLat = lat;
              }

              if (minLat > lat) {
                minLat = lat;
              }

              if (maxLng < lng) {
                maxLng = lng;
              }

              if (minLng > lng) {
                minLng = lng;
              }
            });

            const _data = [
              {
                lat: maxLat,
                lng: minLng
              },
              {
                lat: maxLat,
                lng: maxLng
              },
              {
                lat: minLat,
                lng: maxLng
              },
              {
                lat: minLat,
                lng: minLng
              }
            ];

            return {
              url: i.tupuUrl,
              latlngs: _data
            };
          }
        });

      if (this.plusImgArr[0]?.url) {
        imgMapData = [...imgMapData, ...this.plusImgArr];
      }

      this.$store.commit('WindFarm/SET_IMAGE', imgMapData);
    },

    async queryBoundaryByregionId(id) {
      return this.$fetch('/windfarm/project/getRegionBoundary', {
        showError: true,
        params: {
          // 拿默认的
          regionId: id
        }
      }).then(res => {
        const { data = {} } = res || [];
        const { regionBoundary = { coordinates: '' } } = data;

        let result = JSON.parse(regionBoundary).coordinates || [];
        return result;
      });
    },

    requestItemsElementMap(type) {
      if (type === 'point') {
        const pointMapData = this.pointsList
          .map(i => {
            const { geometryInfo } = i;
            const latAndLon = JSON.parse(geometryInfo).coordinates || [];
            const [lon, lat] = latAndLon;

            return {
              lat: lat,
              lon: lon,
              id: i.itemId,
              type: 'res-point',
              iconSize: [25, 40],
              iconAnchor: [13, 54],
              icon: require('@/asset/windfarm/marker-icon.png')
            };
          });

        this.$store.commit('WindFarm/SET_RAW_MARKERS', {
          type: 'res-point',
          data: pointMapData
        });
      }

      if (type === 'face') {
        const areaMapData = this.areasList
          .filter(i => !!i.visible)
          .filter(i => i.itemType != 4)
          .map(ii => {
            const arr = parseGeoInfoToMapData(ii.geometryInfo)[0];
            return arr.map(iii => ({
              ...iii,
              id: ii.itemId,
              type: 'faceItems',
                visible: ii.visible || false
            }));
          });

        const xingzheng = this.areasList
          .filter(i => !!i.visible)
          .filter(i => i.itemType == 4)
          .map(ii => {
            if (ii.itemType == 4) {
              const result = JSON.parse(ii.geometryInfo).coordinates || [];
              ii.mapGeo = result;
              const fuzhi = cloneDeep(result);
              this.getMap(fuzhi, ii.itemId);
              return fuzhi;
            } else {
              const arr = parseGeoInfoToMapData(ii.geometryInfo)[0];
              return arr.map(iii => ({
                ...iii,
                id: ii.itemId,
                type: 'faceItems',
                visible: ii.visible || false
              }));
            }
          });

        this.$store.commit('WindFarm/SET_RAW_POLYGONS_ARR', {
          type: 'faceItems_xingzheng',
          data: xingzheng
        });

        this.$store.commit('WindFarm/SET_RAW_POLYGONS', {
          type: 'faceItems',
          data: areaMapData
        });
      }
    },
    handleResCancel(item) {
      item.isEditName = false;
      item.itemName = item.wipStore['itemName'];
    },
    handleResCheck(item) {
      if (item.itemName.length > 10) {
        return this.$message.warning('资源名称最多只能填写10个字符');
      }

      this.$postForm('/windfarm/project/updateItemName', {
        data: {
          itemId: item.itemId,
          itemName: item.itemName
        },
        showSuccess: true,
        showError: true
      }).then(() => {
        item.isEditName = false;
      });
    },
    handleResDel(item) {
      this.$confirm('是否删除该要素', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
        closeOnClickModal: false
      }).then(() => {
        this.$postForm('/windfarm/project/deleteItem', {
          data: {
            itemId: item.itemId
          },
          showError: true,
          showSuccess: true
        }).then(() => {
          let type = '';
          let activeItem = null;

          if (this.activeFaceItem) {
            type = 'face';
            activeItem = this.activeFaceItem;
          }

          if (this.activePointItem) {
            type = 'point';
            activeItem = this.activePointItem;
          }

          if (item.itemId === activeItem?.itemId) {
            if (type === 'face') {
              this.$refs?.face.handleCloseModalClick();
            }

            if (type === 'point') {
              this.$refs?.point.handleCloseModalClick('point');
              this.$refs?.point.handleCloseModalClick('chart');
            }
          }

          if(!type){
            type = item.itemType == 1? 'point':'face';
          }
          this.queryWindfarmAndItemList(() => {
            type === 'face' && this.requestImg();
            type === 'face' && this.requestItemsElementMap('face');
            type === 'point' && this.requestItemsElementMap('point');
          });
        });
      });
    },
    handleResEdit(item) {
      item.isEditName = true;
      item.wipStore['itemName'] = item.itemName;
    },
    queryWindFarmList() {},

    queryWrgInfo(myItem) {
      this.$store.dispatch('WindFarm/getWrgInfo', {
        params: {
          windfarmId: myItem.windfarmId
        }
      });
    },

    queryRoad(myItem, cb = () => {}) {
      this.$store.dispatch('WindFarm/getRoadList', {
        params: {
          windfarmId: myItem.windfarmId
        },
        callback: cb
      });
    },
    expand(windfarmId) {
      if (windfarmId) {
        const myItem = this.farmList.find(item => item.id == windfarmId);
        if (myItem) {
          if (this.farmList.length === 1) {
            this.handleShowContent(true, 0, myItem);
          }
          // myItem.isShow = true;
        }
      } else {
        const { name, query } = this.$route;

        if (['resource', 'deploy', 'road', 'line', 'power'].includes(name)) {
          const { windfarmId } = query;
          const myItem = this.farmList.find(item => item.id == windfarmId);

          if (myItem) {
            this.farmList.forEach(item => {
              item.isShow = false;
            });
            myItem.isShow = true;
            this.currentItem = myItem;

            // this.createWindFarmInMap(myItem.geometryInfo, true);
            // this.createLimitArea(myItem);
            // this.createBoosterMarker(myItem);
            // this.queryWindfarmTurbineList(myItem);
            // this.queryRoad(myItem);
            // this.queryWrgInfo(myItem);
          } else {
            this.cleanWindFarmInMap();
          }
        }

        if (name === 'project-detail') {
          const myItem = this.farmList.find(
            item => item.id == sessionStorage.getItem('farmId')
          );

          if (myItem) {
            this.farmList.forEach(item => {
              item.isShow = false;
            });
            myItem.isShow = true;
            this.currentItem = myItem;
          }
        }
      }
    },

    createBoosterMarker(myItem) {
      this.$store.dispatch('WindFarm/getBoosterList', {
        params: {
          windfarmId: myItem.windfarmId
        }
      });
    },
    createLimitArea(myItem) {
      this.$store.dispatch('WindFarm/getWindfarmExclusive', {
        params: {
          windfarmId: myItem.windfarmId
        }
      });
    },

    handleWindFarmItemClick(item) {
      this.resetActiveItem();

      if (!item) {
        return this.$router.push({
          name: 'project-detail',
          query: {
            projectId: this.$route.query.projectId,
            form: 0
          }
        });
      }

      const { routerName, id } = item;
      if (routerName) {
        this.$router.push({
          name: routerName,
          query: {
            windfarmId: id,
            projectId: this.$route.query.projectId
          }
        });
      }
    },
    handleBodyClick(e) {
      if (this.$refs.input === e.target) return;

      this.isProjectNameEdit = false;

      const projectName = localStorage.getItem('current-project-name');
      if (projectName !== this.projectName)
        this.$postForm('/windfarm/project/updateProjectName', {
          data: {
            projectId: this.$route.query.projectId,
            projectName: this.projectName
          },
          showError: true,
          showSuccess: true
        }).then(() => {
          localStorage.setItem('current-project-name', this.projectName);
        });
    },
    handlePlainTextClick() {
      // this.isProjectNameEdit = true;
    },

    handlePrecondition() {
      if (this.specificDragFlag) {
        this.resultFj();

        if (this.hasDrag) {
          return false;
        }
        return true;
      }
      return true;
    },

    handleShowContent(show, index, item) {
      if (show) {
        this.$nextTick(() => {
          this.setSessionStorage('farmId', item.windfarmId);
        });
        this.currentItem = item;
        item.isEditWindFarm = false;
        this.handleWindFarmCancel(item);

        this.farmList.forEach(_item => {
          if (_item !== item) {
            _item.isShow = false;
          }
        });

        this.createLimitArea(item);
        this.createWindFarmInMap(item.geometryInfo, true);
        this.createBoosterMarker(item);
        this.queryWindfarmTurbineList(item);
        this.queryRoad(item, () => {
          const { name } = this.$route;

          if (name === 'road') {
            this.$nextTick(() => {
              this.resultClickDl();
            });
          }
        });
        this.queryWrgInfo(item);

        setTimeout(() => {
          this.queryWires(item);
        }, 500);
        return;
      } else {
        this.setSessionStorage('farmId', '');
        item.isEditWindFarm = false;
        this.handleWindFarmCancel(item);
      }

      if (this.farmList.every(i => !i.isShow)) {
        this.cleanWindFarmInMap();
      }
    },

    handleCardTitleClick() {
      const { name } = this.$route;

      if (name !== 'project-detail') {
        this.$router.push({
          name: 'project-detail',
          query: {
            projectId: this.$route.query.projectId
          }
        });
      }
      // this.$router.push({
      //   path: this.$route.path,
      //   query: {
      //     windfarmId: item.windfarmId,
      //     projectId: this.$route.query.projectId
      //   }
      // });
    },

    handleFinanceClick(item) {
      this.$router.push({
        name: 'estimate',
        query: {
          windfarmId: item.windfarmId,
          projectId: this.$route.query.projectId
        }
      });
    },

    queryWires(
      myItem,
      type = '2',
      callback = () => {},
      usePrev = false,
      item = 'all'
    ) {
      this.$store.dispatch('WindFarm/getWindFarmWire', {
        params: {
          type,
          windfarmId: myItem.windfarmId
        },
        callback,
        usePrev,
        circuit: item
      });
    }
  }
};
</script>

<style lang="less" scoped>
  .vtn-wrp {
    text-align: right;
    margin-top: 10px;
  }
  .downBtn{
    min-width: 105px;
    height: 32px;
    border-radius: 8px;
    display: inline-block;
      font-size: 14px;
      font-weight: bold;
      -webkit-box-sizing: border-box;
      box-sizing: border-box;
      color: #FFFFFF;
      text-align: center;
      cursor: pointer;
      position: relative;
    border:0;
  }
  .downBtnColor{
    background: -webkit-gradient(linear, left top, right top, from(#0878bf), to(#0056aa));
    background: linear-gradient(to right, #0878bf, #0056aa);
  }
  .disDownBtnColor{
    background: #99b8d0;
  }
.wind-farm-project-detail-bar {
  width: 217px;
  position: absolute;
  top: 4px;
  left: 0.3%;
  border-radius: 10px;
  z-index: 450;
  display: flex;
  flex-direction: column;
  background-color: #c8e0f5;
  max-height: 94%;

  .content-bar {
    height: 100%;
    padding-bottom: 10px;

    .content {
      overflow: auto;
      //border-radius: 0 0 10px 10px;
    }
    .title {
      margin-top: 8px;
      height: 20px;
      line-height: 20px;
      font-size: 16px;
      padding-left: 20px;
      position: relative;
      margin-bottom: 3px;
      background-color: #c8e0f5;
      &:before {
        content: '';
        display: block;
        position: absolute;
        top: 50%;
        transform: translateY(-50%);
        left: 10px;
        width: 5px;
        border-radius: 5px;
        height: 18px;
        background-color: #015aac;
      }
    }
  }

  .inner-content {
    background-color: #c8e0f5;
    padding-left: 10px;
  }

  .nav-bar {
    border-radius: 10px 10px 0 0;
    height: 50px;
    min-height: 50px;
    display: flex;
    padding: 0px 20px 0 10px;
    color: #ffffff;
    font-size: 17px;
    align-items: center;
    background: #015aad;
    // background: linear-gradient(
    //   to bottom,
    //   #76b4de 0%,
    //   #9fcaea 20%,
    //   #c8e0f5 50%,
    //   #c8e0f5 100%
    // );
    i {
      cursor: pointer;
      font-size: 22px;
      font-weight: bold;
      //color: #0877be;
      margin-right: 5px;
    }
  }

  .input-container {
    flex: 1;

    .plain-text {
      width: 160px;
      line-height: 25px;
      border-radius: 5px;
      padding-left: 10px;

      overflow: hidden; //超出的文本隐藏
      text-overflow: ellipsis; //溢出用省略号显示
      white-space: nowrap; //溢出不换行
    }
    input {
      height: 25px;
      border-radius: 5px;
      font-size: 14px;
    }
  }
}
</style>

<style lang="less">
.wind-farm-main-container {
  position: relative;
  .leaflet-popup-close-button {
    display: none;
  }
  .leaflet-popup-content-wrapper {
    color: #ffffff;
    border-radius: 7px;
    opacity: 0.95;

    .leaflet-popup-content {
      width: auto !important;
    }
  }
  .leaflet-popup-tip {
    display: none;
  }
}
</style>
